module.exports = __webpack_public_path__ + "img/home_hnews8_2.c55b7214.png";